import script from "./DropDown.vue?vue&type=script&setup=true&lang=js"
export * from "./DropDown.vue?vue&type=script&setup=true&lang=js"

import "./DropDown.vue?vue&type=style&index=0&id=5d1e5d23&lang=css"

const __exports__ = script;

export default __exports__